import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/components/View';
import HubSpotCreditsFeatures from '../key-features/HubSpotCreditsFeatures';
import { HubSpotCreditsTilesContainer } from '../merch-card/hubspot-credits/HubSpotCreditsTilesContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnlockAIContentLayout = ({
  subscreen,
  unlockHubSpotCreditsSkuIds = [],
  title
}) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/_jsxs(View, {
      backgroundColor: "fill-surface-default",
      padding: "0",
      children: [/*#__PURE__*/_jsx(HubSpotCreditsTilesContainer, {
        subscreen: subscreen,
        unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
        title: title
      }), /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })]
    });
  }
  return /*#__PURE__*/_jsx(CardWrapper, {
    padding: "1300",
    borderRadius: "300",
    borderWidth: "100",
    blockSize: "100%",
    marginBlock: "0",
    children: /*#__PURE__*/_jsxs(CardSection, {
      padding: "0",
      children: [/*#__PURE__*/_jsx(HubSpotCreditsTilesContainer, {
        subscreen: subscreen,
        unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
        title: title
      }), /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })]
    })
  });
};
export default UnlockAIContentLayout;